module.exports = __webpack_public_path__ + "img/icon_pay_wechat.0cffacd1.png";